import React, { useEffect } from 'react';
import {
  DataTable,
  Field,
  DataTableAction,
} from '../../components/data-table/DataTable';

import { DateView, TextView, TextViewDef } from '../../components/view-fields';
import { useSelector, useDispatch } from 'react-redux';
import { State } from '../../store/interfaces';
import { actions as dashboardActions } from '../../store/reducers/dashboard';
import { ContainerLoader } from '../../components/loader';
import Button from '../../components/button';
import ClickLink from '../../components/click-link';
import { useHistory } from 'react-router';

interface CheckListProps {
  item: any
}
const CheckList: React.SFC<CheckListProps> = (
  props: CheckListProps
) => {
  const renderSkills = () => {
    const records = props.item
      ? props.item.map((item:any) => ({
          ...item,
        }))
      : [];

    const actions: DataTableAction[] = [];
    const showActionsIf: any = false;
    return (
       props.item && (
        <DataTable
          records={records}
          actions={actions}
          showActionsIf={showActionsIf}
        >
      
          <Field component={TextView} source="name" label={"Skill"} />
          <Field component={TextViewDef} source="intialRating" label="Initial Assesment Rating (1-4)" />
          <Field
            component={TextViewDef}
            source="developmentOutComes"
            label="Development Outcomes"
          />
        </DataTable>
      )
    );
  };

  return (
    <div className="PaymentHistory2  mb-4" style={{border:"1px solid #989898"}}>
      {renderSkills()}
    </div>
  );
};

export default CheckList;
